import type { Lawyer } from "src/constants/lawyers";

const BANNER_IMAGE = "/lawyer-detail-banner.webp";

const S3_BASE =
  "https://vws-front-store.s3.ap-northeast-2.amazonaws.com/company/lawyers";

interface LawyerBannerProps {
  lawyer: Lawyer;
}

export function LawyerBanner({ lawyer }: LawyerBannerProps) {
  return (
    <section className="bg-gradient-to-b from-[#EEF5FF] to-white pt-4 tablet:pt-12">
      {/* 이름 + 타이틀 */}
      <div className="py-5 px-4 tablet:px-8 desktop:pt-5 desktop:pb-10 desktop:px-0 flex items-end gap-2 max-w-[1150px] mx-auto">
        <h1 className="text-display-1-mb desktop:text-display-1">
          {lawyer.name}
        </h1>
        <span className="text-display-2-mb desktop:text-display-2 text-[#666666]">
          {lawyer.title}
        </span>
      </div>

      {/* 이미지 */}
      <div
        className="relative h-[312px] tablet:h-[544px] desktop:h-[500px] max-w-[1350px] mx-auto bg-cover bg-center desktop:rounded-2xl"
        style={{ backgroundImage: `url(${BANNER_IMAGE})` }}
      >
        <img
          src={`${S3_BASE}/${lawyer.slug}.webp`}
          alt={`${lawyer.name} ${lawyer.title}`}
          className="absolute bottom-0 left-0 h-full object-contain"
        />
      </div>
    </section>
  );
}
